import React, {Component} from 'react';

class Api extends Component{
    
    state = {
      data: []
    };    

    // Code is invoked after the component is mounted/inserted into the DOM tree.
    componentDidMount(){
        //const url = "https://en.wikipedia.org/w/api.php?action=opensearch=Seona+Dancing&format=json&origin=*";
        const url = "https://dummyjson.com/products/2";

        fetch(url)
          .then(result => result.json())
          .then(result => {
            this.setState({
                data: result
            })
          });
    }

    render(){
        const {data} = this.state;
        const arrEntries = Object.entries(data);  // Object.keys(data);    Object.values(data);
        console.log(arrEntries);

        const result = arrEntries.map( ([key, value]) => {
            return <li key={key}>{key} : {value}</li>;
        });

        return<ul>{result}</ul>;
    }

}

export default Api;